export enum FileCounterTextColors {
    primary = 'primary',
    secondary = 'secondary',
}
